import { NavBar } from "@/widgets";
import { Content, UpContainer, Wrapper } from "./styles";

type BackOfficeLayoutProps = {
  isMobile: boolean;
  children: React.ReactNode;
};

export function BackOfficeLayout({
  isMobile,
  children,
}: BackOfficeLayoutProps): JSX.Element {
  return (
    <Wrapper>
      {isMobile ? (
        <>
          <Content>THIS IS MOBILE</Content>
        </>
      ) : (
        <>
          <UpContainer>
            <NavBar />
          </UpContainer>
          <Content>{children}</Content>
        </>
      )}
    </Wrapper>
  );
}
